import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative z-[2] border-t border-white/10 bg-white/[0.03] mt-24">
      <div data-testid="footer-disclaimer" className="border-b border-white/10 bg-black/20">
        <div className="max-w-7xl mx-auto px-6 py-6 space-y-2">
          <p className="text-muted-foreground text-xs leading-relaxed">
            These statements have not been evaluated by the Food and Drug Administration (FDA). These products are not designed to diagnose, treat, cure, or prevent any disease or health condition.
          </p>
          <p className="text-muted-foreground text-xs leading-relaxed">
            Every product offered on this website is intended exclusively for laboratory and scientific research use. By placing an order, you certify that you are at least 18 years old, that you are a qualified researcher or professional, and that you will store, handle, and use these materials responsibly and in full compliance with all applicable laws and regulations.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo_mark.png" alt="Mulan Peptide Collection" className="h-14 w-14 object-contain" />
              <span className="font-head font-semibold text-2xl tracking-[0.12em] text-primary">MULAN PEPTIDE COLLECTION</span>
            </div>
            <p className="text-muted-foreground text-sm max-w-sm leading-relaxed mb-6">
              High-purity research peptides for laboratory investigation. Every compound is third-party verified for identity, net content and purity.
            </p>
            <h4 className="label-mono text-primary mb-3">Contact Info</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><span className="text-foreground">Email:</span> <a href="mailto:support@mulanpeptidecollection.com" className="hover:text-primary transition-colors">support@mulanpeptidecollection.com</a></li>
              <li><span className="text-foreground">Location:</span> USA</li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <h4 className="label-mono text-primary mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground transition-colors">Home</Link></li>
              <li><Link to="/p/about" className="hover:text-foreground transition-colors">About</Link></li>
              <li><Link to="/shop" className="hover:text-foreground transition-colors">Shop</Link></li>
              <li><Link to="/shop" className="hover:text-foreground transition-colors">COA</Link></li>
              <li><Link to="/p/contact" className="hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="label-mono text-primary mb-4">Policies</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link to="/p/disclaimer" className="hover:text-foreground transition-colors">Disclaimer</Link></li>
              <li><Link to="/p/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/p/terms" className="hover:text-foreground transition-colors">Terms &amp; Conditions</Link></li>
              <li><Link to="/p/refund" className="hover:text-foreground transition-colors">Refund Policy</Link></li>
              <li><Link to="/p/shipping" className="hover:text-foreground transition-colors">Shipping Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-primary/15 flex flex-col md:flex-row justify-between gap-4">
          <p className="label-mono text-muted-foreground text-[0.6rem]">© {new Date().getFullYear()} Mulan Peptide Collection LLC</p>
          <p className="label-mono text-muted-foreground text-[0.6rem]">Research Use Only · Made for Science</p>
        </div>
      </div>
    </footer>
  );
}
